import React, { useState } from 'react';

import styled from 'styled-components';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import BankAccountsDrawer from '@components/BankAccounts/BankAccountsDrawer';
//import { useContact } from '@hooks/Contact/UseContact';
import NwIcon from '@components/Gui/NwIcon';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

// import { Badge } from "antd";
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ContactLegalContainer = styled.p`
    text-transform: uppercase;
    margin-bottom: 0;
`;

const ContactDetailsBankAccounts = ({ currentContact, readOnly, mobileFullRow }) => {
    const [drawer, setDrawer] = useState(false);
    //const { data: currentContact, isFetching } = useContact(contactId);
    const breakpoints = useNwBreakPoints();

    const handleOpenDrawer = () => {
        setDrawer(true);
    };

    const renderContactBankAccountsContainer = () => {
        return currentContact.BankAccountsCount ? (
            <ContactLegalContainer onClick={mobileFullRow ? undefined : handleOpenDrawer}>
                {breakpoints !== 1 && (
                    <>
                        <NwIcon icon={byPrefixAndName.fasl['piggy-bank']} />
                        &nbsp;&nbsp;
                    </>
                )}
                {currentContact.BankAccountsCount}{' '}
                {currentContact.BankAccountsCount > 1 ? 'bank account' : 'bank accounts'}
            </ContactLegalContainer>
        ) : (
            <ContactLegalContainer onClick={mobileFullRow ? undefined : handleOpenDrawer}>
                <NwIcon icon={byPrefixAndName.fasl['piggy-bank']} danger />
                &nbsp;&nbsp;no bank accounts
            </ContactLegalContainer>
        );
    };

    return (
        <>
            {currentContact && (
                <div
                    className={`header-body-boxes header-body-boxes-hoverable${mobileFullRow ? ' mobile-full-row-trigger' : ''}`}
                    onClick={mobileFullRow ? handleOpenDrawer : undefined}
                >
                    <PermissionBlock permission={true} content={renderContactBankAccountsContainer()} />
                </div>
            )}
            {drawer && (
                <BankAccountsDrawer
                    contactId={currentContact.ID}
                    readOnly={readOnly}
                    onClose={() => setDrawer(false)}
                />
            )}
        </>
    );
};

export default ContactDetailsBankAccounts;
